import { Row, Col, Card, Divider, Icon, Modal } from 'antd';
import { RegistrationCode422Modal } from '@bit/ui-common.ui-components/ss-components';
import { ssFormUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import * as formConfig from './formConfig';

const 
{ setEnvPrefix } = ssCommonUtils,
{ generateInitState } = ssFormUtils;

class Li extends React.Component {
    constructor(props) { super(props); }
    render = () => (
        <li>
            <span style={{ lineHeight: '18px', fontSize: '13px', fontWeight: 'bold' }}>
                {this.props.children}
            </span>
        </li>
    );
}

export default class DodWelcome extends React.Component {
    constructor(props) {
        super(props);

        const { state: { stepStatus }, services, controls } = props;
        controls.step.next(() => {
            if(stepStatus === 'invalid') {
                services.dodWelcomeUpdateStatus('valid');
                services.dodWelcomeUpdateTitle((
                    <div>
                        <Icon type='check-circle-o' />
                        {' Step 1'}
                    </div>
                ));
            }
        });

        this.buildAllFormState();
    }

    buildAllFormState() {
        const
        { services, registrationForm } = this.props,
        { storeForm } = services,
        formConfigList = [
            formConfig.dodPersonalInformationConfig,
            formConfig.dodOfficeAddressConfig,
            formConfig.dodCredentialsConfig,
            formConfig.dodSecurityConfig,
            formConfig.dodAuthConfig
        ];

        for(let k in formConfigList)
            if(!registrationForm[formConfigList[k].key])
                storeForm(formConfigList[k].key, generateInitState(formConfigList[k]));
    }

    render() {
        const 
        { services, state, dod, captcha, passwordReset, registrationForm } = this.props,
        { showPasswordResetModal } = dod.data,
        reset = () => {
            services.toggleModalPasswordResetRequest();
            services.resetCaptchaValidation();
            services.clearRequestPasswordReset();
        },
        here = (
            <div 
                className='registration-password-reset-help-text'
                onClick={() => services.toggleModalPasswordResetRequest()}
            >
                {'here'}
            </div>
        );
        
        return (
            <div>
                <Modal
                    visible={showPasswordResetModal}
                    centered={true}
                    footer={null}
                    closable={false}
                    width={0}
                >
                    <RegistrationCode422Modal data={{
                        altClass: true,
                        captcha,
                        showPasswordResetModal,
                        toggleModalPasswordResetRequest: () => services.toggleModalPasswordResetRequest(),
                        passwordResetRequest: passwordReset.request,
                        form: registrationForm,
                        storeForm: services.storeForm,
                        storeFormField: services.storeFormField,
                        captchaServices: {
                            validateCaptcha: services.validateCaptcha,
                            checkCaptcha: services.checkCaptcha,
                            updateCaptchaField: services.updateCaptchaField,
                            loadCaptcha: services.loadCaptcha,
                            resetCaptchaValidation: services.resetCaptchaValidation 
                        },
                        modalOnClick: () => reset(),
                        submitPasswordReset: field => services.requestPasswordReset(field, captcha.field),
                        onResetSuccess: () => {
                            reset();
                            window.location.href = setEnvPrefix('/home');
                        },
                        onResetFailure: () => reset()
                    }} />
                </Modal>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={17}>
                        <Card
                            hoverable
                            bodyStyle={{ padding: '0 30px 30px 30px' }}
                            style={{ cursor: 'default' }}
                        >
                            <Row style={{ marginBottom: '20px' }}>
                                <Col span={24}>
                                    <Divider>
                                        <div style={{ textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                            <span style={{ color: 'rgb(53, 158, 255)' }}>
                                                {'Welcome to the Flight Training Security Program!'}
                                            </span>
                                        </div>
                                    </Divider>
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: '20px' }}>
                                <Col span={24}>
                                    <span style={{ lineHeight: '18px', fontSize: '13px' }}>
                                        {` You are beginning the process of creating a US DoD Attaché account on the `}
                                        {`Flight Training Security Program (FTSP) online portal. Please make sure you have `}
                                        {`the following ready:`}
                                    </span>
                                </Col>
                            </Row>
                            <Row  type='flex' justify='space-around' align='middle'>
                                <Col>
                                    <ul>
                                        <Li>
                                            {`A valid US Military (.mil) or Government (.gov) email address we can use to `}
                                            {`send you your ID and password.`}
                                        </Li>
                                    </ul>
                                </Col>
                            </Row>
                            <Divider type='horizontal'>
                                <span style={{ fontStyle: 'italic', fontSize: '11px', color: 'grey' }}>
                                    {'Info'}
                                </span>
                            </Divider>
                            <Row>
                                <Col span={24}>
                                    <span style={{ lineHeight: '18px', fontSize: '13px' }}>
                                        {`If you have previously created an account, but have forgotten your password, `}
                                        {`please click `} {here} {` to have your login information emailed to you. Do NOT `}
                                        {`attempt to create a new account. If you have questions or concerns, please `}
                                        {`contact us at FTSP.Help@tsa.dhs.gov or (571) 227-1004.`}
                                    </span>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
